import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Panel } from "@/components/extranet/StatusBadge";

const Count = ({ n, max, testid }) => (
  <span data-testid={testid} className={`text-xs ${n > max ? "font-semibold text-red-600" : "text-slate-500"}`}>{n}/{max}</span>
);

const plain = (s) => (s || "").replace(/\*\*/g, "").replace(/\s+/g, " ").slice(0, 160);

export default function SeoPanel({ f, setF, save, t }) {
  const [lang, setLang] = useState("id");
  const sfx = lang === "en" ? "_en" : "";
  const tk = `seo_title${sfx}`;
  const dk = `seo_description${sfx}`;
  const title = f[tk] || (lang === "en" && f.seo_title) || `${f.name} — ${f.city}`;
  const desc = f[dk] || (lang === "en" && (f.seo_description || plain(f.description_en))) || plain(f.description);
  const url = f.custom_domain ? `https://${f.custom_domain}` : `${window.location.origin}/p/${f.slug}`;
  return (
    <Panel title={t("SEO (Google)")} className="lg:col-span-5" testid="property-seo">
      <div className="grid gap-4 p-5 md:grid-cols-2">
        <div className="space-y-4">
          <div className="inline-flex overflow-hidden rounded-md border border-slate-200 text-xs font-bold">
            {["id", "en"].map((l) => <button key={l} type="button" data-testid={`seo-lang-${l}`} onClick={() => setLang(l)} className={`px-3 py-1.5 uppercase ${lang === l ? "bg-[#006CE4] text-white" : "bg-white text-slate-600"}`}>{l === "id" ? "Indonesia" : "English"}</button>)}
          </div>
          <div><div className="flex justify-between"><Label>{t("Judul SEO")} ({lang.toUpperCase()})</Label><Count n={(f[tk] || "").length} max={60} testid="seo-title-count" /></div>
            <Input data-testid={`prop-seo-title${sfx.replace("_", "-")}`} maxLength={120} value={f[tk] || ""} onChange={(e) => setF({ ...f, [tk]: e.target.value })} placeholder={`${f.name} — ${f.city}`} className="mt-1.5" /></div>
          <div><div className="flex justify-between"><Label>{t("Deskripsi SEO")} ({lang.toUpperCase()})</Label><Count n={(f[dk] || "").length} max={160} testid="seo-desc-count" /></div>
            <Textarea data-testid={`prop-seo-description${sfx.replace("_", "-")}`} maxLength={320} rows={4} value={f[dk] || ""} onChange={(e) => setF({ ...f, [dk]: e.target.value })} className="mt-1.5" /></div>
          <p className="text-xs text-slate-500">{t("Ideal: judul ≤ 60 karakter, deskripsi 120–160 karakter. Kosongkan untuk memakai nama & deskripsi properti.")}</p>
        </div>
        <div className="rounded-md border border-slate-200 bg-white p-4" data-testid="seo-preview">
          <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">{t("Pratinjau Google")} · {lang.toUpperCase()}</p>
          <p className="truncate text-xs text-slate-600">{url}</p>
          <p className="mt-1 line-clamp-1 text-lg text-[#1A0DAB]">{title}</p>
          <p className="mt-1 line-clamp-2 text-sm text-slate-600">{desc}</p>
        </div>
        <div className="md:col-span-2"><button data-testid="prop-seo-save-button" onClick={save} className="rounded-md bg-[#006CE4] px-5 py-2 font-semibold text-white hover:bg-[#0052B4]">{t("Simpan perubahan")}</button></div>
      </div>
    </Panel>
  );
}
